import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge precisa conhecer a escala do DS: sem isso, `text-micro` seria
 * tratado como COR e removido ao lado de `text-muted`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["display", "h-xl", "h-lg", "h-md", "lead", "body", "body-sm", "micro"],
      tracking: ["display", "heading", "tight", "micro"],
      shadow: ["card", "pop"],
      animate: [
        "menu-pop",
        "modal-pop",
        "cascade-in",
        "shake",
        "pulse-subtle",
        "skeleton",
        "row-in",
        "bar-in",
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
